import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	shareFeedbackButtonTextExtension: {
		id: 'company-hub.company-hub-common.config-panel.feedback-section.share-feedback-button.text-extension',
		defaultMessage:
			'{type, select, Cards {Give feedback on Cards} Carousel {Give feedback on Carousel} Linksmenu {Give feedback on Links menu} Spotlight {Give feedback on Spotlight} Section {Give feedback on Section} Customsearch {Give feedback on Custom Search} Companyhub {Give feedback on Company hub} other {Share your thoughts}}',
		description:
			'Text for button to open the feedback collector modal where user can share feedback on the given extension',
	},
	feedbackCollectorModalPreambleFirstLine: {
		id: 'company-hub.company-hub-common.config-panel.feedback-collector.preamble.first-line',
		defaultMessage:
			'Your input is valuable and allows us to better meet your needs. What could be improved?',
		description:
			'First line of text in the feedback collector modal which is above the input box where feedback will be typed.',
	},
	feedbackCollectorModalSummaryPlaceholder: {
		id: 'company-hub.company-hub-common.config-panel.feedback-collector.summary-placeholder',
		defaultMessage: 'What works well? What could be improved?',
		description: 'Placeholder text inside input box of feedback collector.',
	},
	feedbackCollectorButtonPreamble: {
		id: 'company-hub.company-hub-common.config-panel.feedback-section.preamble',
		defaultMessage: 'Your feedback helps us improve.',
		description: 'Preamble shown to user to let them know we are looking for feedback.',
	},
});
